import { routeList } from '@/router/helpers/routes'
import { validateRouteMandatoryProps } from '@/router/helpers/validations'
/* Views */
import PendingSignature from '@/views/approvals/PendingSignature'
import Signed from '@/views/approvals/Signed'
import OperatorsConsult from '@/views/approvals/operators/Consult'
import OperatorsCreate from '@/views/approvals/operators/Create'
import OperatorsEdit from '@/views/approvals/operators/Edit'
import OperatorsDelete from '@/views/approvals/operators/Delete'
import OperatorsBlock from '@/views/approvals/operators/Block'
import OperatorsUnblock from '@/views/approvals/operators/Unblock'
import UnderDevelopment from '@/views/UnderDevelopment'

export default [{
	path: routeList.APPROVALS_BASE_PATH,
	beforeEnter (to, from, next) {
		next(false)
	}
},
{
	path: routeList.APPROVALS_PENDING_SIGNATURE_PATH,
	name: routeList.APPROVALS_PENDING_SIGNATURE_NAME,
	props: true,
	component: PendingSignature
},
/* ***********************************************
*                    OPERATORS                   *
*********************************************** */
{
	path: routeList.APPROVALS_OPERATORS_PATH,
	name: routeList.APPROVALS_OPERATORS_NAME,
	component: OperatorsConsult
}, {
	path: routeList.APPROVALS_OPERATORS_CREATE_PATH,
	name: routeList.APPROVALS_OPERATORS_CREATE_NAME,
	component: OperatorsCreate
}, {
	path: routeList.APPROVALS_OPERATORS_EDIT_PATH,
	name: routeList.APPROVALS_OPERATORS_EDIT_NAME,
	props: true,
	component: OperatorsEdit,
	beforeEnter (to, from, next) {
		validateRouteMandatoryProps(to, from, next, routeList.APPROVALS_OPERATORS_NAME)
	}
}, {
	path: routeList.APPROVALS_OPERATORS_DELETE_PATH,
	name: routeList.APPROVALS_OPERATORS_DELETE_NAME,
	props: true,
	component: OperatorsDelete,
	beforeEnter (to, from, next) {
		validateRouteMandatoryProps(to, from, next, routeList.APPROVALS_OPERATORS_NAME)
	}
}, {
	path: routeList.APPROVALS_OPERATORS_BLOCK_PATH,
	name: routeList.APPROVALS_OPERATORS_BLOCK_NAME,
	props: true,
	component: OperatorsBlock,
	beforeEnter (to, from, next) {
		validateRouteMandatoryProps(to, from, next, routeList.APPROVALS_OPERATORS_NAME)
	}
}, {
	path: routeList.APPROVALS_OPERATORS_UNBLOCK_PATH,
	name: routeList.APPROVALS_OPERATORS_UNBLOCK_NAME,
	props: true,
	component: OperatorsUnblock,
	beforeEnter (to, from, next) {
		validateRouteMandatoryProps(to, from, next, routeList.APPROVALS_OPERATORS_NAME)
	}
},
/* ******************************************** */
{
	path: routeList.APPROVALS_SIGNED_PATH,
	name: routeList.APPROVALS_SIGNED_NAME,
	component: Signed
}]
